export default "__VITE_ASSET__D8s96cIh__"